export const lifeStageList = [
    {
        label: "LifeStage",
        options: [
            {
                label: "Young Independent",
                value: "Young Independent",
                name: "Young Independent"
            },
            {
                label: "New Families",
                value: "New Families",
                name: "New Families"
            },
            {
                label: "Established Families",
                value: "Established Families",
                name: "Established Families"
            },
            {
                label: "Late Career",
                value: "Late Career",
                name: "Late Career"
            },
            {
                label: "Retirees",
                value: "Retirees",
                name: "Retirees"
            }]
    }
]
